import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-quantity-and-size',
  templateUrl: './column-quantity-and-size.component.html',
  styleUrls: ['./column-quantity-and-size.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnQuantityAndSizeComponent extends ColumnComponent {
  @Input() useNgContent: boolean;
}
